export default __webpack_public_path__ + "static/media/indent.a9eabf41.svg";